import accountableHelper from "./accountables";

function buildLegalRepresentativeAttributes(legalRepresentative) {
  return {
    attributes: {
      first_name: legalRepresentative.firstName,
      last_name: legalRepresentative.lastName,
      cpf: legalRepresentative.cpf,
      birthdate: legalRepresentative.birthdate,
      address: legalRepresentative.address,
      phone: legalRepresentative.phone
    }
  };
}

function createRequestBody(payload) {
  const {
    account,
    profile,
    phones
  } = accountableHelper.buildAccountableRelationships(payload);
  return {
    data: {
      attributes: {
        cnpj: payload.legal.cnpj,
        company_name: payload.legal.company_name,
        business_name: payload.legal.business_name
      },
      relationships: {
        account,
        profile,
        phones,
        legal_representative: buildLegalRepresentativeAttributes(
          payload.legalRepresentative
        )
      }
    }
  };
}

export default { createRequestBody };



// WEBPACK FOOTER //
// ./src/API/helpers/legals.js